import { render, staticRenderFns } from "./Exmp.vue?vue&type=template&id=1810cb1c&scoped=true"
import script from "./Exmp.vue?vue&type=script&lang=js"
export * from "./Exmp.vue?vue&type=script&lang=js"
import style0 from "./Exmp.vue?vue&type=style&index=0&id=1810cb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810cb1c",
  null
  
)

export default component.exports